type mainTabsMetaProps = {
	type: string;
	label: string;
};
type LoadingByType = Record<string, boolean>;
type TabConfigParams = {
	data?: any;
	types: string[];
	isShow?: boolean;
	loadingByType?: LoadingByType;
};

export const structureFormKeys = [
	"hbaGte","hbaLte","hbdGte","hbdLte","tpsaGte","tpsaLte",
	"fsp3Gte","logPGte","logPLte","linkers","compounds",
	"typeStructure","searchSimilarity","heavyAtomCountGte","heavyAtomCountLte",
	"molecularWeightGte","molecularWeightLte","rotatableBondCountGte","rotatableBondCountLte"
];

export const typeStructureSearch = ['compounds', 'linkers'];
export const typeBioSearch = ['compounds', 'drugs', 'impurities'];
export const typeListByIdSearch = ['compounds', 'drugs', 'impurities', 'chemicalProbes'];
export const typeTextSearch = ['compounds', 'libraries', 'drugs', 'impurities', 'chemicalProbes'];

const mainTabsMeta: mainTabsMetaProps[] = [
	{ type: 'compounds', label: 'EBC' },
	{ type: 'compounds', label: 'Compounds' },
	{ type: 'drugs', label: 'Drugs' },
	{ type: 'impurities', label: 'Impurities' },
	{ type: 'chemicalProbes', label: 'Chemical probes' },
	{ type: 'libraries', label: 'Libraries' },
	{ type: 'linkers', label: 'Linkers' }
];

export const getFormData = (formKeys: string[],getValues: any) => {
	return formKeys.reduce((acc, key) => {
		acc[key] = getValues(key as any);
		return acc;
	}, {} as Record<string, any>);
};

export const createTabsConfig = (props: TabConfigParams) => {
	const {
		data,
		types,
		isShow = true,
		loadingByType = {},
	} = props;
	return types.map((type) => {
		const meta = mainTabsMeta.find(
			(m) => m.type === type
		);

		const total =
			data?.[type]?.totalElements ??
			data?.[type]?.baseBaData?.length ??
			0;

		return {
			type,
			variable: 'tab',
			loading: loadingByType[type] ?? false,
			label: (
				<>
					<span>{meta?.label}</span>
					<b className="relative">{isShow ? total : 0}</b>
				</>
			)
		};
	}).filter(Boolean);
};